const W = 0.52;
const M = 0.06;

export const mainKeys = {
  "#00070029": { text: "Esc", style: { marginRight: M * 2 + W + "rem" } },
  "#0007003A": { text: "F1" },
  "#0007003B": { text: "F2" },
  "#0007003C": { text: "F3" },
  "#0007003D": {
    text: "F4",
    style: { marginRight: M + (M + W) * 0.5 + "rem" },
  },
  "#0007003E": { text: "F5" },
  "#0007003F": { text: "F6" },
  "#00070040": { text: "F7" },
  "#00070041": {
    text: "F8",
    style: { marginRight: M + (M + W) * 0.5 + "rem" },
  },
  "#00070042": { text: "F9" },
  "#00070043": { text: "F10" },
  "#00070044": { text: "F11" },
  "#00070045": { text: "F12" },
  "#00070035": { text: "~<br/>`" },
  "#0007001E": { text: "!<br/>1" },
  "#0007001F": { text: "@<br/>2" },
  "#00070020": { text: "#<br/>3" },
  "#00070021": { text: "$<br/>4" },
  "#00070022": { text: "%<br/>5" },
  "#00070023": { text: "^<br/>6" },
  "#00070024": { text: "&<br/>7" },
  "#00070025": { text: "*<br/>8" },
  "#00070026": { text: "(<br/>9" },
  "#00070027": { text: ")<br/>0" },
  "#0007002D": { text: "_<br/>-" },
  "#0007002E": { text: "+<br/>=" },
  "#0007002A": { text: "Backspace", style: { width: W * 2 + M + "rem" } },
  "#0007002B": { text: "Tab", style: { width: W + (W + M) * 0.5 + "rem" } },
  "#00070014": { text: "Q" },
  "#0007001A": { text: "W" },
  "#00070008": { text: "E" },
  "#00070015": { text: "R" },
  "#00070017": { text: "T" },
  "#0007001C": { text: "Y" },
  "#00070018": { text: "U" },
  "#0007000C": { text: "I" },
  "#00070012": { text: "O" },
  "#00070013": { text: "P" },
  "#0007002F": { text: "{<br/>[" },
  "#00070030": { text: "}<br/>]" },
  "#00070031": {
    text: "|<br/>\\",
    style: { width: W + (W + M) * 0.5 + "rem" },
  },
  "#00070039": { text: "CapsLock", style: { width: W + W * 0.75 + M + "rem" } },
  "#00070004": { text: "A" },
  "#00070016": { text: "S" },
  "#00070007": { text: "D" },
  "#00070009": { text: "F" },
  "#0007000A": { text: "G" },
  "#0007000B": { text: "H" },
  "#0007000D": { text: "J" },
  "#0007000E": { text: "K" },
  "#0007000F": { text: "L" },
  "#00070033": { text: ":<br/>;" },
  "#00070034": { text: "\"<br/>'" },
  "#00070028": { text: "Enter", style: { width: W + W * 1.25 + M + "rem" } },
  "#000700E1": {
    text: "LShift",
    style: { width: W + W * 1.25 + M * 1.5 + "rem" },
  },
  "#0007001D": { text: "Z" },
  "#0007001B": { text: "X" },
  "#00070006": { text: "C" },
  "#00070019": { text: "V" },
  "#00070005": { text: "B" },
  "#00070011": { text: "N" },
  "#00070010": { text: "M" },
  "#00070036": { text: "<<br/>," },
  "#00070037": { text: "><br/>." },
  "#00070038": { text: "?<br/>/" },
  "#000700E5": {
    text: "RShift",
    style: { width: W + W * 1.75 + M * 1.5 + "rem" },
  },
  "#000700E0": { text: "LCtrl", style: { width: W * 1.3 + "rem" } },
  "#000700E3": { text: "LWin/Cmd", style: { width: W * 1.3 + "rem" } },
  "#000700E2": { text: "LAlt/Opt", style: { width: W * 1.3 + "rem" } },
  "#0007002C": { text: "Space", style: { width: W * 6.7 + "rem" } },
  "#000700E6": { text: "RAlt/Opt", style: { width: W * 1.3 + "rem" } },
  "#000700E7": { text: "RWin/Cmd", style: { width: W * 1.3 + "rem" } },
  "#00070065": { text: "Menu", style: { width: W * 1.3 + "rem" } },
  "#000700E4": { text: "RCtrl", style: { width: W * 1.3 + "rem" } },
};

export const centerClusterKeys = {
  "#00070046": { text: "Print Screen" },
  "#00070047": { text: "Scroll Lock" },
  "#00070048": { text: "Pause" },
  "#00070049": { text: "Insert" },
  "#0007004A": { text: "Home" },
  "#0007004B": { text: "Page Up" },
  "#0007004C": { text: "Delete" },
  "#0007004D": { text: "End" },
  "#0007004E": { text: "Page Down" },
  "#00070052": {
    text: "↑",
    style: {
      marginTop: M + W + "rem",
      marginRight: M + W + "rem",
      marginLeft: M + W + "rem",
    },
  },
  "#00070050": { text: "←" },
  "#00070051": { text: "↓" },
  "#0007004F": { text: "→" },
};

export const numpadKeys = {
  "#00070053": {
    text: "Num Lock",
    style: { marginTop: M + W + "rem" },
  },
  "#00070054": { text: "/", style: { marginTop: M + W + "rem" } },
  "#00070055": { text: "*", style: { marginTop: M + W + "rem" } },
  "#00070056": { text: "-", style: { marginTop: M + W + "rem" } },
  "#0007005F": { text: "7" },
  "#00070060": { text: "8" },
  "#00070061": { text: "9" },
  "#00070057": { text: "+" },
  "#0007005C": { text: "4" },
  "#0007005D": { text: "5" },
  "#0007005E": { text: "6", style: { marginRight: M + W + "rem" } },
  "#00070059": { text: "1" },
  "#0007005A": { text: "2" },
  "#0007005B": { text: "3", style: { marginRight: M + W + "rem" } },
  "#00070062": { text: "0", style: { width: M + W * 2 + "rem" } },
  "#00070063": { text: "." },
  "#00070058": { text: "Enter" },
};

export const mediaKeys = {
  "#000C00E2": {
    text: "Mute",
  },
  "#000C00E9": {
    text: "Volume Up",
  },
  "#000C00EA": {
    text: "Volume Down",
  },
  "#000C00B6": {
    text: "Prev Track",
  },
  "#000C00B5": {
    text: "Next Track",
  },
  "#000C00CD": {
    text: "Play/ Pause",
  },
};

export const fnKeys = {
  "#00920106": {
    text: "BT_1",
    desc: "BT_1",
  },
  "#00920107": {
    text: "BT_2",
    desc: "BT_2",
  },
  "#00920108": {
    text: "BT_3",
    desc: "BT_3",
  },
  "#00920130": {
    text: "2.4G",
    desc: "2_4G",
  },
  "#00920922": {
    text: "Win/ Mac",
    desc: "Win/ Mac",
  },
  "#00900001": {
    text: "Esc `",
    style: { whiteSpace: "nowrap" },
    desc: "Esc `",
  },
  "#00921300": {
    text: "Touch Sen",
    desc: "Touch Sen",
  },
  "#00920A02": {
    text: "Reset",
    desc: "Reset",
  },
  "#00920900": {
    text: "Next PCB",
    desc: "Next PCB",
  },
  "#00920901": {
    text: "PCB Light+",
    desc: "PCB Light+",
  },
  "#00920902": {
    text: "PCB Light-",
    desc: "PCB Light-",
  },
  "#00920903": {
    text: "PCB On/Off",
    desc: "PCB On/Off",
  },
  "#00920904": {
    text: "PCB Speed+",
    desc: "PCB Speed+",
  },
  "#00920905": {
    text: "PCB Speed-",
    desc: "PCB Speed-",
  },
  "#0092090B": {
    text: "NP Light+",
    desc: "NP Light+",
  },
  "#0092090C": {
    text: "NP Light-",
    desc: "NP Light-",
  },
  "#0092090D": {
    text: "NP On/Off",
    desc: "NP On/Off",
  },
  "#0092090E": {
    text: "NP Color",
    desc: "NP Color",
  },
  "#0092090F": {
    text: "Next NP",
    desc: "Next NP",
  },
  "#00920910": {
    text: "Battery",
    desc: "Battery",
  },
  "#00920C0F": {
    text: "Layer1",
    desc: "Layer1",
  },
  "#00920C10": {
    text: "Layer2",
    desc: "Layer2",
  },
  "#00920C11": {
    text: "Layer3",
    desc: "Layer3",
  },
  "#00920C12": {
    text: "Layer4",
    desc: "Layer4",
  },
  "#00920C13": {
    text: "Layer5",
    desc: "Layer5",
  },
  "#00920C14": {
    text: "Layer6",
    desc: "Layer6",
  },
  "#00920C15": {
    text: "Layer7",
    desc: "Layer7",
  },
  "#00920C20": {
    text: "Fn1",
    desc: "Fn1",
  },
  "#00920C0B": {
    text: "Fn2",
    desc: "Fn2",
  },
  "#00920C22": {
    text: "Fn3",
    desc: "Fn3",
  },
  "#00920C23": {
    text: "Fn4",
    desc: "Fn4",
  },
  "#00920C24": {
    text: "Fn5",
    desc: "Fn5",
  },
  "#00920C25": {
    text: "Fn6",
    desc: "Fn6",
  },
  "#00920C26": {
    text: "Fn7",
    desc: "Fn7",
  },
  "#00910010": {
    text: "S Fn1",
    style: { whiteSpace: "nowrap" },
    desc: "S Fn1",
  },
  "#00910011": {
    text: "S Fn2",
    style: { whiteSpace: "nowrap" },
    desc: "S Fn2",
  },
  "#00910012": {
    text: "S Fn3",
    style: { whiteSpace: "nowrap" },
    desc: "S Fn3",
  },
  "#00910013": {
    text: "S Fn4",
    style: { whiteSpace: "nowrap" },
    desc: "S Fn4",
  },
  "#00910014": {
    text: "S Fn5",
    style: { whiteSpace: "nowrap" },
    desc: "S Fn5",
  },
  "#00910015": {
    text: "S Fn6",
    style: { whiteSpace: "nowrap" },
    desc: "S Fn6",
  },
  "#00910016": {
    text: "S Fn7",
    style: { whiteSpace: "nowrap" },
    desc: "S Fn7",
  },
};

const keys = {
  ...mainKeys,
  ...centerClusterKeys,
  ...numpadKeys,
  ...mediaKeys,
  ...fnKeys,
};

const sortedKeys = {};

const keyArray = Object.keys(keys).sort();
keyArray.splice(
  keyArray.indexOf("#00920C20"),
  0,
  keyArray.splice(keyArray.indexOf("#00920C0B"), 1)[0]
);
keyArray.map((key) => {
  keys[key].nowrapText = keys[key].text.replace("<br/>", " ");
  sortedKeys[key] = keys[key];
});

export const allKeys = { ...sortedKeys };

delete sortedKeys["#00900001"];
delete sortedKeys["#00910010"];
delete sortedKeys["#00910011"];
delete sortedKeys["#00910012"];
delete sortedKeys["#00910013"];
delete sortedKeys["#00910014"];
delete sortedKeys["#00910015"];
delete sortedKeys["#00910016"];

export const holdKeys = { ...sortedKeys };

delete sortedKeys["#0092090B"];
delete sortedKeys["#0092090C"];
delete sortedKeys["#0092090E"];
delete sortedKeys["#00920A02"];
delete sortedKeys["#00920C20"];
delete sortedKeys["#00920C0B"];
delete sortedKeys["#00920C22"];
delete sortedKeys["#00920C23"];
delete sortedKeys["#00920C24"];
delete sortedKeys["#00920C25"];
delete sortedKeys["#00920C26"];

export const pressKeys = { ...sortedKeys };

for (const key in mediaKeys) {
  delete sortedKeys[key];
}

for (const key in fnKeys) {
  delete sortedKeys[key];
}

export const basicKeys = {};

for (const key in sortedKeys) {
  basicKeys[key.replace("#00", "#11")] = {
    ...sortedKeys[key],
    nowrapText: "↓ " + sortedKeys[key].text.replace(/^.+<br\/>/, ""),
  };
  basicKeys[key.replace("#00", "#10")] = {
    ...sortedKeys[key],
    nowrapText: "↑ " + sortedKeys[key].text.replace(/^.+<br\/>/, ""),
  };
}
